import { ViewFactory } from 'wdc-cube-react'

import { UserManagerScope } from '../um_scopes'

import { HeaderScope } from '../um_scopes'
import UserManagerView from './um_view'
import HeaderView from './um-header'

export function registerViews(rv = ViewFactory.register) {
    rv(UserManagerScope, UserManagerView)
    rv(HeaderScope, HeaderView)
}
